// Puedes poner esto en un archivo Modal.js o dentro de Login.js/Signup.js si prefieres
import React from "react";
import "./Modal.css";
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
    }}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 24, maxWidth: 750, width: "90%", position: "relative" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 8, right: 12, fontSize: 22, background: "none", border: "none", cursor: "pointer" }}>×</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;